import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { DealImpl } from "../model/impl/DealImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class DealImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: DealImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.id != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(1),
        false,
        encodable.id,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.orderId != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(2),
        false,
        encodable.orderId,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.orderType != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(3),
        false,
        encodable.orderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.entryUserId != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(4),
        false,
        encodable.entryUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroupId != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(5),
        false,
        encodable.salesGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.clientBranchCode != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(6),
        false,
        encodable.clientBranchCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.dealtCcy != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(7),
        false,
        encodable.dealtCcy,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.allocationId != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(8),
        false,
        encodable.allocationId,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.amt1 != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(9),
        false,
        encodable.amt1,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.amt2 != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(10),
        false,
        encodable.amt2,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.creationDate != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(11),
        false,
        encodable.creationDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.dealStateId != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(12),
        false,
        encodable.dealStateId,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.spotClientRate != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(13),
        false,
        encodable.spotClientRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.forwardPoints != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(14),
        false,
        encodable.forwardPoints,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.allInClientRate != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(15),
        false,
        encodable.allInClientRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.spotTraderMargin != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(16),
        false,
        encodable.spotTraderMargin,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.spotSalesMargin != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(17),
        false,
        encodable.spotSalesMargin,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.forwardSalesMargin != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(18),
        false,
        encodable.forwardSalesMargin,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.forwardTraderMargin != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(19),
        false,
        encodable.forwardTraderMargin,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.salesMargin != null) {
      this.baseEncoder.writeStartFid(20, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(20),
        false,
        encodable.salesMargin,
        streamout,
      );
      this.baseEncoder.writeEndFid(20, streamout);
    }
    /*Object encoding*/
    if (encodable.dealerMargin != null) {
      this.baseEncoder.writeStartFid(21, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(21),
        false,
        encodable.dealerMargin,
        streamout,
      );
      this.baseEncoder.writeEndFid(21, streamout);
    }
    /*Object encoding*/
    if (encodable.spotMarketRate != null) {
      this.baseEncoder.writeStartFid(22, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(22),
        false,
        encodable.spotMarketRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(22, streamout);
    }
    /*Object encoding*/
    if (encodable.forwardMarketPoints != null) {
      this.baseEncoder.writeStartFid(23, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(23),
        false,
        encodable.forwardMarketPoints,
        streamout,
      );
      this.baseEncoder.writeEndFid(23, streamout);
    }
    /*Object encoding*/
    if (encodable.forwardMarketRate != null) {
      this.baseEncoder.writeStartFid(24, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(24),
        false,
        encodable.forwardMarketRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(24, streamout);
    }
    /*Object encoding*/
    if (encodable.fillUserId != null) {
      this.baseEncoder.writeStartFid(25, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(25),
        false,
        encodable.fillUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(25, streamout);
    }
    /*Object encoding*/
    if (encodable.localBookId != null) {
      this.baseEncoder.writeStartFid(26, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(26),
        false,
        encodable.localBookId,
        streamout,
      );
      this.baseEncoder.writeEndFid(26, streamout);
    }
    /*Object encoding*/
    if (encodable.remoteBookId != null) {
      this.baseEncoder.writeStartFid(27, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(27),
        false,
        encodable.remoteBookId,
        streamout,
      );
      this.baseEncoder.writeEndFid(27, streamout);
    }
    /*Object encoding*/
    if (encodable.valueDate != null) {
      this.baseEncoder.writeStartFid(28, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(28),
        false,
        encodable.valueDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(28, streamout);
    }
    /*Object encoding*/
    if (encodable.valueDateTenor != null) {
      this.baseEncoder.writeStartFid(29, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(29),
        false,
        encodable.valueDateTenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(29, streamout);
    }
    /*Object encoding*/
    if (encodable.traderGroupId != null) {
      this.baseEncoder.writeStartFid(30, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(30),
        false,
        encodable.traderGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(30, streamout);
    }
    /*Object encoding*/
    if (encodable.productId != null) {
      this.baseEncoder.writeStartFid(31, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(31),
        false,
        encodable.productId,
        streamout,
      );
      this.baseEncoder.writeEndFid(31, streamout);
    }
    /*Object encoding*/
    if (encodable.isBuy != null) {
      this.baseEncoder.writeStartFid(32, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(32),
        false,
        encodable.isBuy,
        streamout,
      );
      this.baseEncoder.writeEndFid(32, streamout);
    }
    /*Object encoding*/
    if (encodable.tradeDate != null) {
      this.baseEncoder.writeStartFid(33, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(33),
        false,
        encodable.tradeDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(33, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDate != null) {
      this.baseEncoder.writeStartFid(34, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(34),
        false,
        encodable.fixingDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(34, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCode != null) {
      this.baseEncoder.writeStartFid(35, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(35),
        false,
        encodable.clientCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(35, streamout);
    }
    /*Object encoding*/
    if (encodable.accountCode != null) {
      this.baseEncoder.writeStartFid(36, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(36),
        false,
        encodable.accountCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(36, streamout);
    }
    /*Object encoding*/
    if (encodable.counterPartyCode != null) {
      this.baseEncoder.writeStartFid(37, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(37),
        false,
        encodable.counterPartyCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(37, streamout);
    }
    /*Object encoding*/
    if (encodable.entryUserCode != null) {
      this.baseEncoder.writeStartFid(38, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(38),
        false,
        encodable.entryUserCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(38, streamout);
    }
    /*Object encoding*/
    if (encodable.productType != null) {
      this.baseEncoder.writeStartFid(39, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(39),
        false,
        encodable.productType,
        streamout,
      );
      this.baseEncoder.writeEndFid(39, streamout);
    }
    /*Object encoding*/
    if (encodable.bookingOrderId != null) {
      this.baseEncoder.writeStartFid(40, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(40),
        false,
        encodable.bookingOrderId,
        streamout,
      );
      this.baseEncoder.writeEndFid(40, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyId != null) {
      this.baseEncoder.writeStartFid(41, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(41),
        false,
        encodable.strategyId,
        streamout,
      );
      this.baseEncoder.writeEndFid(41, streamout);
    }
    /*Object encoding*/
    if (encodable.usdEquivAmt != null) {
      this.baseEncoder.writeStartFid(42, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(42),
        false,
        encodable.usdEquivAmt,
        streamout,
      );
      this.baseEncoder.writeEndFid(42, streamout);
    }
    /*Object encoding*/
    if (encodable.requestedPx != null) {
      this.baseEncoder.writeStartFid(44, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(44),
        false,
        encodable.requestedPx,
        streamout,
      );
      this.baseEncoder.writeEndFid(44, streamout);
    }
    /*Object encoding*/
    if (encodable.clientComment != null) {
      this.baseEncoder.writeStartFid(45, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(45),
        false,
        encodable.clientComment,
        streamout,
      );
      this.baseEncoder.writeEndFid(45, streamout);
    }
    /*Object encoding*/
    if (encodable.privateComment != null) {
      this.baseEncoder.writeStartFid(46, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(46),
        false,
        encodable.privateComment,
        streamout,
      );
      this.baseEncoder.writeEndFid(46, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingCode != null) {
      this.baseEncoder.writeStartFid(47, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(47),
        false,
        encodable.fixingCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(47, streamout);
    }
    /*Object encoding*/
    if (encodable.confirmedSalesUserId != null) {
      this.baseEncoder.writeStartFid(48, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(48),
        false,
        encodable.confirmedSalesUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(48, streamout);
    }
    /*Object encoding*/
    if (encodable.bookingIds != null) {
      this.baseEncoder.writeStartFid(49, streamout);
      this.baseEncoder.writeObject(
        true,
        DealImplEncoder.fidTypeMap.get(49),
        false,
        encodable.bookingIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(49, streamout);
    }
    /*Object encoding*/
    if (encodable.confirmedSalesUserCode != null) {
      this.baseEncoder.writeStartFid(50, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(50),
        false,
        encodable.confirmedSalesUserCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(50, streamout);
    }
    /*Object encoding*/
    if (encodable.confirmedSalesUserName != null) {
      this.baseEncoder.writeStartFid(51, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(51),
        false,
        encodable.confirmedSalesUserName,
        streamout,
      );
      this.baseEncoder.writeEndFid(51, streamout);
    }
    /*Object encoding*/
    if (encodable.fillComment != null) {
      this.baseEncoder.writeStartFid(52, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(52),
        false,
        encodable.fillComment,
        streamout,
      );
      this.baseEncoder.writeEndFid(52, streamout);
    }
    /*Object encoding*/
    if (encodable.algoStrategyName != null) {
      this.baseEncoder.writeStartFid(53, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(53),
        false,
        encodable.algoStrategyName,
        streamout,
      );
      this.baseEncoder.writeEndFid(53, streamout);
    }
    /*Object encoding*/
    if (encodable.clOrdId != null) {
      this.baseEncoder.writeStartFid(54, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(54),
        false,
        encodable.clOrdId,
        streamout,
      );
      this.baseEncoder.writeEndFid(54, streamout);
    }
    /*Object encoding*/
    if (encodable.entryDate != null) {
      this.baseEncoder.writeStartFid(55, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(55),
        false,
        encodable.entryDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(55, streamout);
    }
    /*Object encoding*/
    if (encodable.fillUserCode != null) {
      this.baseEncoder.writeStartFid(56, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(56),
        false,
        encodable.fillUserCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(56, streamout);
    }
    /*Object encoding*/
    if (encodable.fillUserName != null) {
      this.baseEncoder.writeStartFid(57, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(57),
        false,
        encodable.fillUserName,
        streamout,
      );
      this.baseEncoder.writeEndFid(57, streamout);
    }
    /*Object encoding*/
    if (encodable.requestOrderType != null) {
      this.baseEncoder.writeStartFid(58, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(58),
        false,
        encodable.requestOrderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(58, streamout);
    }
    /*Object encoding*/
    if (encodable.baseCcyCd != null) {
      this.baseEncoder.writeStartFid(59, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(59),
        false,
        encodable.baseCcyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(59, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBaseCcyCd != null) {
      this.baseEncoder.writeStartFid(60, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(60),
        false,
        encodable.nonBaseCcyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(60, streamout);
    }
    /*Object encoding*/
    if (encodable.isInvert != null) {
      this.baseEncoder.writeStartFid(61, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(61),
        false,
        encodable.isInvert,
        streamout,
      );
      this.baseEncoder.writeEndFid(61, streamout);
    }
    /*Object encoding*/
    if (encodable.entryUserName != null) {
      this.baseEncoder.writeStartFid(62, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(62),
        false,
        encodable.entryUserName,
        streamout,
      );
      this.baseEncoder.writeEndFid(62, streamout);
    }
    /*Object encoding*/
    if (encodable.aggregateId != null) {
      this.baseEncoder.writeStartFid(63, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(63),
        false,
        encodable.aggregateId,
        streamout,
      );
      this.baseEncoder.writeEndFid(63, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerBidRate != null) {
      this.baseEncoder.writeStartFid(64, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(64),
        false,
        encodable.triggerBidRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(64, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerOfferRate != null) {
      this.baseEncoder.writeStartFid(65, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(65),
        false,
        encodable.triggerOfferRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(65, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerSide != null) {
      this.baseEncoder.writeStartFid(66, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(66),
        false,
        encodable.triggerSide,
        streamout,
      );
      this.baseEncoder.writeEndFid(66, streamout);
    }
    /*Object encoding*/
    if (encodable.holdStp != null) {
      this.baseEncoder.writeStartFid(67, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(67),
        false,
        encodable.holdStp,
        streamout,
      );
      this.baseEncoder.writeEndFid(67, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerTime != null) {
      this.baseEncoder.writeStartFid(68, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(68),
        false,
        encodable.triggerTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(68, streamout);
    }
    /*Object encoding*/
    if (encodable.manualDealReference != null) {
      this.baseEncoder.writeStartFid(69, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(69),
        false,
        encodable.manualDealReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(69, streamout);
    }
    /*Object encoding*/
    if (encodable.marketBidRateAtFill != null) {
      this.baseEncoder.writeStartFid(70, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(70),
        false,
        encodable.marketBidRateAtFill,
        streamout,
      );
      this.baseEncoder.writeEndFid(70, streamout);
    }
    /*Object encoding*/
    if (encodable.marketOfferRateAtFill != null) {
      this.baseEncoder.writeStartFid(71, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(71),
        false,
        encodable.marketOfferRateAtFill,
        streamout,
      );
      this.baseEncoder.writeEndFid(71, streamout);
    }
    /*Object encoding*/
    if (encodable.componentDetails != null) {
      this.baseEncoder.writeStartFid(72, streamout);
      this.baseEncoder.writeObject(
        true,
        DealImplEncoder.fidTypeMap.get(72),
        false,
        encodable.componentDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(72, streamout);
    }
    /*Object encoding*/
    if (encodable.dealConfirmations != null) {
      this.baseEncoder.writeStartFid(73, streamout);
      this.baseEncoder.writeObject(
        true,
        DealImplEncoder.fidTypeMap.get(73),
        false,
        encodable.dealConfirmations,
        streamout,
      );
      this.baseEncoder.writeEndFid(73, streamout);
    }
    /*Object encoding*/
    if (encodable.localBookName != null) {
      this.baseEncoder.writeStartFid(74, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(74),
        false,
        encodable.localBookName,
        streamout,
      );
      this.baseEncoder.writeEndFid(74, streamout);
    }
    /*Object encoding*/
    if (encodable.remoteBookName != null) {
      this.baseEncoder.writeStartFid(75, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(75),
        false,
        encodable.remoteBookName,
        streamout,
      );
      this.baseEncoder.writeEndFid(75, streamout);
    }
    /*Object encoding*/
    if (encodable.fillState != null) {
      this.baseEncoder.writeStartFid(76, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(76),
        false,
        encodable.fillState,
        streamout,
      );
      this.baseEncoder.writeEndFid(76, streamout);
    }
    /*Object encoding*/
    if (encodable.lastMkt != null) {
      this.baseEncoder.writeStartFid(77, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(77),
        false,
        encodable.lastMkt,
        streamout,
      );
      this.baseEncoder.writeEndFid(77, streamout);
    }
    /*Object encoding*/
    if (encodable.transactTime != null) {
      this.baseEncoder.writeStartFid(78, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(78),
        false,
        encodable.transactTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(78, streamout);
    }
    /*Object encoding*/
    if (encodable.isPrivate != null) {
      this.baseEncoder.writeStartFid(79, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(79),
        false,
        encodable.isPrivate,
        streamout,
      );
      this.baseEncoder.writeEndFid(79, streamout);
    }
    /*Object encoding*/
    if (encodable.clientName != null) {
      this.baseEncoder.writeStartFid(80, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(80),
        false,
        encodable.clientName,
        streamout,
      );
      this.baseEncoder.writeEndFid(80, streamout);
    }
    /*Object encoding*/
    if (encodable.accountName != null) {
      this.baseEncoder.writeStartFid(81, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(81),
        false,
        encodable.accountName,
        streamout,
      );
      this.baseEncoder.writeEndFid(81, streamout);
    }
    /*Object encoding*/
    if (encodable.clientSegment != null) {
      this.baseEncoder.writeStartFid(82, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(82),
        false,
        encodable.clientSegment,
        streamout,
      );
      this.baseEncoder.writeEndFid(82, streamout);
    }
    /*Object encoding*/
    if (encodable.isClientIsTraderVisible != null) {
      this.baseEncoder.writeStartFid(83, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(83),
        false,
        encodable.isClientIsTraderVisible,
        streamout,
      );
      this.baseEncoder.writeEndFid(83, streamout);
    }
    /*Object encoding*/
    if (encodable.counterPartyDetails != null) {
      this.baseEncoder.writeStartFid(84, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(84),
        true,
        encodable.counterPartyDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(84, streamout);
    }
    /*Object encoding*/
    if (encodable.isClientStraightThroughProcessing != null) {
      this.baseEncoder.writeStartFid(85, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(85),
        false,
        encodable.isClientStraightThroughProcessing,
        streamout,
      );
      this.baseEncoder.writeEndFid(85, streamout);
    }
    /*Object encoding*/
    if (encodable.clientTraderName != null) {
      this.baseEncoder.writeStartFid(86, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(86),
        false,
        encodable.clientTraderName,
        streamout,
      );
      this.baseEncoder.writeEndFid(86, streamout);
    }
    /*Object encoding*/
    if (encodable.clientTraderId != null) {
      this.baseEncoder.writeStartFid(87, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(87),
        false,
        encodable.clientTraderId,
        streamout,
      );
      this.baseEncoder.writeEndFid(87, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyType != null) {
      this.baseEncoder.writeStartFid(88, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(88),
        false,
        encodable.strategyType,
        streamout,
      );
      this.baseEncoder.writeEndFid(88, streamout);
    }
    /*Object encoding*/
    if (encodable.clientBranchCd != null) {
      this.baseEncoder.writeStartFid(89, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(89),
        false,
        encodable.clientBranchCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(89, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCd != null) {
      this.baseEncoder.writeStartFid(90, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(90),
        false,
        encodable.clientCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(90, streamout);
    }
    /*Object encoding*/
    if (encodable.baseCurrencyCd != null) {
      this.baseEncoder.writeStartFid(91, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(91),
        false,
        encodable.baseCurrencyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(91, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBaseCurrencyCd != null) {
      this.baseEncoder.writeStartFid(92, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(92),
        false,
        encodable.nonBaseCurrencyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(92, streamout);
    }
    /*Object encoding*/
    if (encodable.customValues != null) {
      this.baseEncoder.writeStartFid(93, streamout);
      this.baseEncoder.writeObject(
        true,
        DealImplEncoder.fidTypeMap.get(93),
        false,
        encodable.customValues,
        streamout,
      );
      this.baseEncoder.writeEndFid(93, streamout);
    }
    /*Object encoding*/
    if (encodable.ownerGroupIds != null) {
      this.baseEncoder.writeStartFid(94, streamout);
      this.baseEncoder.writeObject(
        true,
        DealImplEncoder.fidTypeMap.get(94),
        false,
        encodable.ownerGroupIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(94, streamout);
    }
    /*Object encoding*/
    if (encodable.lastOwnerGroupIds != null) {
      this.baseEncoder.writeStartFid(95, streamout);
      this.baseEncoder.writeObject(
        true,
        DealImplEncoder.fidTypeMap.get(95),
        false,
        encodable.lastOwnerGroupIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(95, streamout);
    }
    /*Object encoding*/
    if (encodable.currencyPairs != null) {
      this.baseEncoder.writeStartFid(96, streamout);
      this.baseEncoder.writeObject(
        true,
        DealImplEncoder.fidTypeMap.get(96),
        false,
        encodable.currencyPairs,
        streamout,
      );
      this.baseEncoder.writeEndFid(96, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDts != null) {
      this.baseEncoder.writeStartFid(97, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(97),
        false,
        encodable.fixingDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(97, streamout);
    }
    /*Object encoding*/
    if (encodable.traderVisibilityOffset != null) {
      this.baseEncoder.writeStartFid(98, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(98),
        false,
        encodable.traderVisibilityOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(98, streamout);
    }
    /*Object encoding*/
    if (encodable.isAggregateDealFg != null) {
      this.baseEncoder.writeStartFid(99, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(99),
        false,
        encodable.isAggregateDealFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(99, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.reqFixingTzCd != null) {
      this.baseEncoder.writeStartFid(101, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(101),
        false,
        encodable.reqFixingTzCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(101, streamout);
    }
    /*Object encoding*/
    if (encodable.currencyPairAndOwners != null) {
      this.baseEncoder.writeStartFid(102, streamout);
      this.baseEncoder.writeObject(
        true,
        DealImplEncoder.fidTypeMap.get(102),
        false,
        encodable.currencyPairAndOwners,
        streamout,
      );
      this.baseEncoder.writeEndFid(102, streamout);
    }
    /*Object encoding*/
    if (encodable.makerDealRef != null) {
      this.baseEncoder.writeStartFid(103, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(103),
        false,
        encodable.makerDealRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(103, streamout);
    }
    /*Object encoding*/
    if (encodable.secondaryMakerDealRef != null) {
      this.baseEncoder.writeStartFid(104, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(104),
        false,
        encodable.secondaryMakerDealRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(104, streamout);
    }
    /*Object encoding*/
    if (encodable.marketMidRateAtFill != null) {
      this.baseEncoder.writeStartFid(105, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(105),
        false,
        encodable.marketMidRateAtFill,
        streamout,
      );
      this.baseEncoder.writeEndFid(105, streamout);
    }
    /*Object encoding*/
    if (encodable.channelCd != null) {
      this.baseEncoder.writeStartFid(106, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(106),
        false,
        encodable.channelCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(106, streamout);
    }
    /*Object encoding*/
    if (encodable.traderGroupNm != null) {
      this.baseEncoder.writeStartFid(107, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(107),
        false,
        encodable.traderGroupNm,
        streamout,
      );
      this.baseEncoder.writeEndFid(107, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroupNm != null) {
      this.baseEncoder.writeStartFid(108, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(108),
        false,
        encodable.salesGroupNm,
        streamout,
      );
      this.baseEncoder.writeEndFid(108, streamout);
    }
    /*Object encoding*/
    if (encodable.clientBookingCd != null) {
      this.baseEncoder.writeStartFid(109, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(109),
        false,
        encodable.clientBookingCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(109, streamout);
    }
    /*Object encoding*/
    if (encodable.accountBookingCd != null) {
      this.baseEncoder.writeStartFid(110, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(110),
        false,
        encodable.accountBookingCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(110, streamout);
    }
    /*Object encoding*/
    if (encodable.externalMarketRt != null) {
      this.baseEncoder.writeStartFid(111, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(111),
        false,
        encodable.externalMarketRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(111, streamout);
    }
    /*Object encoding*/
    if (encodable.aggregationType != null) {
      this.baseEncoder.writeStartFid(112, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(112),
        false,
        encodable.aggregationType,
        streamout,
      );
      this.baseEncoder.writeEndFid(112, streamout);
    }
    /*Object encoding*/
    if (encodable.alternateAccountCode != null) {
      this.baseEncoder.writeStartFid(113, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(113),
        false,
        encodable.alternateAccountCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(113, streamout);
    }
    /*Object encoding*/
    if (encodable.executionType != null) {
      this.baseEncoder.writeStartFid(114, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(114),
        false,
        encodable.executionType,
        streamout,
      );
      this.baseEncoder.writeEndFid(114, streamout);
    }
    /*Object encoding*/
    if (encodable.oboClient != null) {
      this.baseEncoder.writeStartFid(115, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(115),
        false,
        encodable.oboClient,
        streamout,
      );
      this.baseEncoder.writeEndFid(115, streamout);
    }
    /*Object encoding*/
    if (encodable.oboAccount != null) {
      this.baseEncoder.writeStartFid(116, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(116),
        false,
        encodable.oboAccount,
        streamout,
      );
      this.baseEncoder.writeEndFid(116, streamout);
    }
    /*Object encoding*/
    if (encodable.dealRef != null) {
      this.baseEncoder.writeStartFid(117, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(117),
        false,
        encodable.dealRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(117, streamout);
    }
    /*Object encoding*/
    if (encodable.orderRef != null) {
      this.baseEncoder.writeStartFid(118, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(118),
        false,
        encodable.orderRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(118, streamout);
    }
    /*Object encoding*/
    if (encodable.allocationRef != null) {
      this.baseEncoder.writeStartFid(119, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(119),
        false,
        encodable.allocationRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(119, streamout);
    }
    /*Object encoding*/
    if (encodable.oboEntryUser != null) {
      this.baseEncoder.writeStartFid(120, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(120),
        false,
        encodable.oboEntryUser,
        streamout,
      );
      this.baseEncoder.writeEndFid(120, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyRef != null) {
      this.baseEncoder.writeStartFid(121, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(121),
        false,
        encodable.strategyRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(121, streamout);
    }
    /*Object encoding*/
    if (encodable.modifyUsers != null) {
      this.baseEncoder.writeStartFid(122, streamout);
      this.baseEncoder.writeObject(
        true,
        DealImplEncoder.fidTypeMap.get(122),
        false,
        encodable.modifyUsers,
        streamout,
      );
      this.baseEncoder.writeEndFid(122, streamout);
    }
    /*Object encoding*/
    if (encodable.dealUpdateTypeId != null) {
      this.baseEncoder.writeStartFid(123, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(123),
        false,
        encodable.dealUpdateTypeId,
        streamout,
      );
      this.baseEncoder.writeEndFid(123, streamout);
    }
    /*Object encoding*/
    if (encodable.nettingId != null) {
      this.baseEncoder.writeStartFid(124, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(124),
        false,
        encodable.nettingId,
        streamout,
      );
      this.baseEncoder.writeEndFid(124, streamout);
    }
    /*Object encoding*/
    if (encodable.benchmarkOrderType != null) {
      this.baseEncoder.writeStartFid(125, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(125),
        false,
        encodable.benchmarkOrderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(125, streamout);
    }
    /*Object encoding*/
    if (encodable.alternateLastMkt != null) {
      this.baseEncoder.writeStartFid(126, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(126),
        false,
        encodable.alternateLastMkt,
        streamout,
      );
      this.baseEncoder.writeEndFid(126, streamout);
    }
    /*Object encoding*/
    if (encodable.spotReservationFg != null) {
      this.baseEncoder.writeStartFid(127, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(127),
        false,
        encodable.spotReservationFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(127, streamout);
    }
    /*Object encoding*/
    if (encodable.spotDealId != null) {
      this.baseEncoder.writeStartFid(128, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(128),
        false,
        encodable.spotDealId,
        streamout,
      );
      this.baseEncoder.writeEndFid(128, streamout);
    }
    /*Object encoding*/
    if (encodable.aggregateRef != null) {
      this.baseEncoder.writeStartFid(129, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(129),
        false,
        encodable.aggregateRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(129, streamout);
    }
    /*Object encoding*/
    if (encodable.spotDealRef != null) {
      this.baseEncoder.writeStartFid(130, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(130),
        false,
        encodable.spotDealRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(130, streamout);
    }
    /*Object encoding*/
    if (encodable.reqFixingTime != null) {
      this.baseEncoder.writeStartFid(131, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(131),
        false,
        encodable.reqFixingTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(131, streamout);
    }
    /*Object encoding*/
    if (encodable.reqFixingDate != null) {
      this.baseEncoder.writeStartFid(132, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(132),
        false,
        encodable.reqFixingDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(132, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdNettingId != null) {
      this.baseEncoder.writeStartFid(133, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(133),
        false,
        encodable.fwdNettingId,
        streamout,
      );
      this.baseEncoder.writeEndFid(133, streamout);
    }
    /*Object encoding*/
    if (encodable.previousFixingDts != null) {
      this.baseEncoder.writeStartFid(134, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(134),
        false,
        encodable.previousFixingDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(134, streamout);
    }
    /*Object encoding*/
    if (encodable.previousTraderVisibilityOffset != null) {
      this.baseEncoder.writeStartFid(135, streamout);
      this.baseEncoder.writeObject(
        false,
        DealImplEncoder.fidTypeMap.get(135),
        false,
        encodable.previousTraderVisibilityOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(135, streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.Long"],
    [2, "java.lang.Long"],
    [3, "com.bcdfx.model.OrderType"],
    [4, "java.lang.Long"],
    [5, "java.lang.Long"],
    [6, "java.lang.String"],
    [7, "java.lang.String"],
    [8, "java.lang.Long"],
    [9, "java.lang.Double"],
    [10, "java.lang.Double"],
    [11, "java.util.Calendar"],
    [12, "com.bcdfx.model.OrderDealState"],
    [13, "java.lang.Double"],
    [14, "java.lang.Double"],
    [15, "java.lang.Double"],
    [16, "java.lang.Double"],
    [17, "java.lang.Double"],
    [18, "java.lang.Double"],
    [19, "java.lang.Double"],
    [20, "java.lang.Double"],
    [21, "java.lang.Double"],
    [22, "java.lang.Double"],
    [23, "java.lang.Double"],
    [24, "java.lang.Double"],
    [25, "java.lang.Long"],
    [26, "java.lang.Long"],
    [27, "java.lang.Long"],
    [28, "java.util.Calendar"],
    [29, "java.lang.String"],
    [30, "java.lang.Long"],
    [31, "java.lang.String"],
    [32, "java.lang.Boolean"],
    [33, "java.util.Calendar"],
    [34, "java.util.Calendar"],
    [35, "java.lang.String"],
    [36, "java.lang.String"],
    [37, "java.lang.String"],
    [38, "java.lang.String"],
    [39, "java.lang.String"],
    [40, "java.lang.Long"],
    [41, "java.lang.Long"],
    [42, "java.lang.Double"],
    [44, "java.lang.Double"],
    [45, "java.lang.String"],
    [46, "java.lang.String"],
    [47, "java.lang.String"],
    [48, "java.lang.Long"],
    [49, "java.lang.String"],
    [50, "java.lang.String"],
    [51, "java.lang.String"],
    [52, "java.lang.String"],
    [53, "java.lang.String"],
    [54, "java.lang.String"],
    [55, "java.util.Date"],
    [56, "java.lang.String"],
    [57, "java.lang.String"],
    [58, "com.bcdfx.model.RequestOrderType"],
    [59, "java.lang.String"],
    [60, "java.lang.String"],
    [61, "java.lang.Boolean"],
    [62, "java.lang.String"],
    [63, "java.lang.Long"],
    [64, "java.lang.Double"],
    [65, "java.lang.Double"],
    [66, "com.bcdfx.model.RateSideType"],
    [67, "java.lang.Boolean"],
    [68, "java.util.Calendar"],
    [69, "java.lang.String"],
    [70, "java.lang.Double"],
    [71, "java.lang.Double"],
    [72, "com.bcdfx.model.DealComponentDetails"],
    [73, "com.bcdfx.model.DealConfirmation"],
    [74, "java.lang.String"],
    [75, "java.lang.String"],
    [76, "com.bcdfx.model.FillState"],
    [77, "java.lang.String"],
    [78, "java.util.Date"],
    [79, "java.lang.Boolean"],
    [80, "java.lang.String"],
    [81, "java.lang.String"],
    [82, "java.lang.String"],
    [83, "java.lang.Boolean"],
    [84, "com.bcdfx.model.event.lifecycle.fx.CounterPartyDetails"],
    [85, "java.lang.Boolean"],
    [86, "java.lang.String"],
    [87, "java.lang.Long"],
    [88, "com.bcdfx.model.StrategyType"],
    [89, "java.lang.String"],
    [90, "java.lang.String"],
    [91, "java.lang.String"],
    [92, "java.lang.String"],
    [93, "com.bcdfx.model.CustomValue"],
    [94, "java.lang.Long"],
    [95, "java.lang.Long"],
    [96, "java.lang.String"],
    [97, "java.util.Date"],
    [98, "java.lang.Long"],
    [99, "java.lang.Boolean"],
    [100, "java.lang.String"],
    [101, "java.lang.String"],
    [102, "com.bcdfx.model.primary.api.BenchmarkVisibilityPairAndOwner"],
    [103, "java.lang.String"],
    [104, "java.lang.String"],
    [105, "java.lang.Double"],
    [106, "java.lang.String"],
    [107, "java.lang.String"],
    [108, "java.lang.String"],
    [109, "java.lang.String"],
    [110, "java.lang.String"],
    [111, "java.lang.Double"],
    [112, "com.bcdfx.model.enums.AggregationType"],
    [113, "java.lang.String"],
    [114, "com.bcdfx.model.ExecutionType"],
    [115, "java.lang.String"],
    [116, "java.lang.String"],
    [117, "java.lang.String"],
    [118, "java.lang.String"],
    [119, "java.lang.String"],
    [120, "java.lang.String"],
    [121, "java.lang.String"],
    [122, "java.lang.String"],
    [123, "com.bcdfx.model.DealUpdateTypeId"],
    [124, "java.lang.String"],
    [125, "com.bcdfx.model.BenchmarkOrderType"],
    [126, "java.lang.String"],
    [127, "java.lang.Boolean"],
    [128, "java.lang.Long"],
    [129, "java.lang.String"],
    [130, "java.lang.String"],
    [131, "java.lang.String"],
    [132, "java.lang.String"],
    [133, "java.lang.String"],
    [134, "java.util.Date"],
    [135, "java.lang.Long"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: DealImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.id = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.orderId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.OrderType = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.orderType = <CubiqTS.OrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.entryUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.salesGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.clientBranchCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.dealtCcy = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.allocationId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.amt1 = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.amt2 = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.creationDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: CubiqTS.OrderDealState = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.dealStateId = <CubiqTS.OrderDealState>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.spotClientRate = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.forwardPoints = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.allInClientRate = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.spotTraderMargin = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.spotSalesMargin = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.forwardSalesMargin = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.forwardTraderMargin = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 20: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(20),
            streamin,
          );
          encodable.salesMargin = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 21: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(21),
            streamin,
          );
          encodable.dealerMargin = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 22: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(22),
            streamin,
          );
          encodable.spotMarketRate = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 23: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(23),
            streamin,
          );
          encodable.forwardMarketPoints = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 24: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(24),
            streamin,
          );
          encodable.forwardMarketRate = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 25: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(25),
            streamin,
          );
          encodable.fillUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 26: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(26),
            streamin,
          );
          encodable.localBookId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 27: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(27),
            streamin,
          );
          encodable.remoteBookId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 28: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(28),
            streamin,
          );
          encodable.valueDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 29: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(29),
            streamin,
          );
          encodable.valueDateTenor = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 30: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(30),
            streamin,
          );
          encodable.traderGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 31: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(31),
            streamin,
          );
          encodable.productId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 32: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(32),
            streamin,
          );
          encodable.isBuy = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 33: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(33),
            streamin,
          );
          encodable.tradeDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 34: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(34),
            streamin,
          );
          encodable.fixingDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 35: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(35),
            streamin,
          );
          encodable.clientCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 36: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(36),
            streamin,
          );
          encodable.accountCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 37: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(37),
            streamin,
          );
          encodable.counterPartyCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 38: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(38),
            streamin,
          );
          encodable.entryUserCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 39: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(39),
            streamin,
          );
          encodable.productType = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 40: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(40),
            streamin,
          );
          encodable.bookingOrderId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 41: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(41),
            streamin,
          );
          encodable.strategyId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 42: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(42),
            streamin,
          );
          encodable.usdEquivAmt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 44: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(44),
            streamin,
          );
          encodable.requestedPx = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 45: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(45),
            streamin,
          );
          encodable.clientComment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 46: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(46),
            streamin,
          );
          encodable.privateComment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 47: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(47),
            streamin,
          );
          encodable.fixingCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 48: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(48),
            streamin,
          );
          encodable.confirmedSalesUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 49: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            DealImplEncoder.fidTypeMap.get(49),
            streamin,
          );
          encodable.bookingIds = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 50: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(50),
            streamin,
          );
          encodable.confirmedSalesUserCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 51: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(51),
            streamin,
          );
          encodable.confirmedSalesUserName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 52: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(52),
            streamin,
          );
          encodable.fillComment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 53: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(53),
            streamin,
          );
          encodable.algoStrategyName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 54: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(54),
            streamin,
          );
          encodable.clOrdId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 55: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(55),
            streamin,
          );
          encodable.entryDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 56: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(56),
            streamin,
          );
          encodable.fillUserCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 57: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(57),
            streamin,
          );
          encodable.fillUserName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 58: {
          /*Object encoding*/
          let val: CubiqTS.RequestOrderType = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(58),
            streamin,
          );
          encodable.requestOrderType = <CubiqTS.RequestOrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 59: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(59),
            streamin,
          );
          encodable.baseCcyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 60: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(60),
            streamin,
          );
          encodable.nonBaseCcyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 61: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(61),
            streamin,
          );
          encodable.isInvert = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 62: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(62),
            streamin,
          );
          encodable.entryUserName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 63: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(63),
            streamin,
          );
          encodable.aggregateId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 64: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(64),
            streamin,
          );
          encodable.triggerBidRate = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 65: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(65),
            streamin,
          );
          encodable.triggerOfferRate = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 66: {
          /*Object encoding*/
          let val: CubiqTS.RateSideType = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(66),
            streamin,
          );
          encodable.triggerSide = <CubiqTS.RateSideType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 67: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(67),
            streamin,
          );
          encodable.holdStp = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 68: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(68),
            streamin,
          );
          encodable.triggerTime = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 69: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(69),
            streamin,
          );
          encodable.manualDealReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 70: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(70),
            streamin,
          );
          encodable.marketBidRateAtFill = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 71: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(71),
            streamin,
          );
          encodable.marketOfferRateAtFill = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 72: {
          /*Object encoding*/
          let val: Array<CubiqTS.DealComponentDetails> = this.baseEncoder.readObject(
            false,
            true,
            DealImplEncoder.fidTypeMap.get(72),
            streamin,
          );
          encodable.componentDetails = <Array<CubiqTS.DealComponentDetails>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 73: {
          /*Object encoding*/
          let val: Array<CubiqTS.DealConfirmation> = this.baseEncoder.readObject(
            false,
            true,
            DealImplEncoder.fidTypeMap.get(73),
            streamin,
          );
          encodable.dealConfirmations = <Array<CubiqTS.DealConfirmation>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 74: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(74),
            streamin,
          );
          encodable.localBookName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 75: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(75),
            streamin,
          );
          encodable.remoteBookName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 76: {
          /*Object encoding*/
          let val: CubiqTS.FillState = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(76),
            streamin,
          );
          encodable.fillState = <CubiqTS.FillState>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 77: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(77),
            streamin,
          );
          encodable.lastMkt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 78: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(78),
            streamin,
          );
          encodable.transactTime = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 79: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(79),
            streamin,
          );
          encodable.isPrivate = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 80: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(80),
            streamin,
          );
          encodable.clientName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 81: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(81),
            streamin,
          );
          encodable.accountName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 82: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(82),
            streamin,
          );
          encodable.clientSegment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 83: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(83),
            streamin,
          );
          encodable.isClientIsTraderVisible = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 84: {
          /*Object encoding*/
          let val: CubiqTS.CounterPartyDetails = this.baseEncoder.readObject(
            true,
            false,
            DealImplEncoder.fidTypeMap.get(84),
            streamin,
          );
          encodable.counterPartyDetails = <CubiqTS.CounterPartyDetails>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 85: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(85),
            streamin,
          );
          encodable.isClientStraightThroughProcessing = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 86: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(86),
            streamin,
          );
          encodable.clientTraderName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 87: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(87),
            streamin,
          );
          encodable.clientTraderId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 88: {
          /*Object encoding*/
          let val: CubiqTS.StrategyType = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(88),
            streamin,
          );
          encodable.strategyType = <CubiqTS.StrategyType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 89: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(89),
            streamin,
          );
          encodable.clientBranchCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 90: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(90),
            streamin,
          );
          encodable.clientCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 91: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(91),
            streamin,
          );
          encodable.baseCurrencyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 92: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(92),
            streamin,
          );
          encodable.nonBaseCurrencyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 93: {
          /*Object encoding*/
          let val: Array<CubiqTS.CustomValue> = this.baseEncoder.readObject(
            false,
            true,
            DealImplEncoder.fidTypeMap.get(93),
            streamin,
          );
          encodable.customValues = <Array<CubiqTS.CustomValue>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 94: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            DealImplEncoder.fidTypeMap.get(94),
            streamin,
          );
          encodable.ownerGroupIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 95: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            DealImplEncoder.fidTypeMap.get(95),
            streamin,
          );
          encodable.lastOwnerGroupIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 96: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            DealImplEncoder.fidTypeMap.get(96),
            streamin,
          );
          encodable.currencyPairs = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 97: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(97),
            streamin,
          );
          encodable.fixingDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 98: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(98),
            streamin,
          );
          encodable.traderVisibilityOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 99: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(99),
            streamin,
          );
          encodable.isAggregateDealFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 101: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(101),
            streamin,
          );
          encodable.reqFixingTzCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 102: {
          /*Object encoding*/
          let val: Array<CubiqTS.BenchmarkVisibilityPairAndOwner> = this.baseEncoder.readObject(
            false,
            true,
            DealImplEncoder.fidTypeMap.get(102),
            streamin,
          );
          encodable.currencyPairAndOwners = <Array<CubiqTS.BenchmarkVisibilityPairAndOwner>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 103: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(103),
            streamin,
          );
          encodable.makerDealRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 104: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(104),
            streamin,
          );
          encodable.secondaryMakerDealRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 105: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(105),
            streamin,
          );
          encodable.marketMidRateAtFill = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 106: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(106),
            streamin,
          );
          encodable.channelCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 107: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(107),
            streamin,
          );
          encodable.traderGroupNm = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 108: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(108),
            streamin,
          );
          encodable.salesGroupNm = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 109: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(109),
            streamin,
          );
          encodable.clientBookingCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 110: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(110),
            streamin,
          );
          encodable.accountBookingCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 111: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(111),
            streamin,
          );
          encodable.externalMarketRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 112: {
          /*Object encoding*/
          let val: CubiqTS.AggregationType = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(112),
            streamin,
          );
          encodable.aggregationType = <CubiqTS.AggregationType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 113: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(113),
            streamin,
          );
          encodable.alternateAccountCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 114: {
          /*Object encoding*/
          let val: CubiqTS.ExecutionType = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(114),
            streamin,
          );
          encodable.executionType = <CubiqTS.ExecutionType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 115: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(115),
            streamin,
          );
          encodable.oboClient = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 116: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(116),
            streamin,
          );
          encodable.oboAccount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 117: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(117),
            streamin,
          );
          encodable.dealRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 118: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(118),
            streamin,
          );
          encodable.orderRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 119: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(119),
            streamin,
          );
          encodable.allocationRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 120: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(120),
            streamin,
          );
          encodable.oboEntryUser = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 121: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(121),
            streamin,
          );
          encodable.strategyRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 122: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            DealImplEncoder.fidTypeMap.get(122),
            streamin,
          );
          encodable.modifyUsers = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 123: {
          /*Object encoding*/
          let val: CubiqTS.DealUpdateTypeId = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(123),
            streamin,
          );
          encodable.dealUpdateTypeId = <CubiqTS.DealUpdateTypeId>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 124: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(124),
            streamin,
          );
          encodable.nettingId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 125: {
          /*Object encoding*/
          let val: CubiqTS.BenchmarkOrderType = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(125),
            streamin,
          );
          encodable.benchmarkOrderType = <CubiqTS.BenchmarkOrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 126: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(126),
            streamin,
          );
          encodable.alternateLastMkt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 127: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(127),
            streamin,
          );
          encodable.spotReservationFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 128: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(128),
            streamin,
          );
          encodable.spotDealId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 129: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(129),
            streamin,
          );
          encodable.aggregateRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 130: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(130),
            streamin,
          );
          encodable.spotDealRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 131: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(131),
            streamin,
          );
          encodable.reqFixingTime = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 132: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(132),
            streamin,
          );
          encodable.reqFixingDate = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 133: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(133),
            streamin,
          );
          encodable.fwdNettingId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 134: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(134),
            streamin,
          );
          encodable.previousFixingDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 135: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            DealImplEncoder.fidTypeMap.get(135),
            streamin,
          );
          encodable.previousTraderVisibilityOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return DealImplEncoder.fidTypeMap.has(fid);
  }
}
